export const LUSER_INIT = 'luser-init';
export const LUSER_TOGGLE_MENU = 'luser-toggle-menu';
export const LUSER_FOLLOW = 'luser-follow';
export const LUSER_UNFOLLOW = 'luser-unfollow';
export const LUSER_TOGGLE_FOLLOW = 'luser-toggle-follow';
export const LUSER_SET_FOLLOW = 'luser-set-follow';
export const LUSER_CHECK_FOLLOWED_INTEGRITY = 'luser-check-followed-integrity';

 

export function toggleMenu(state) {
  	return { type: LUSER_TOGGLE_MENU, state };
}
 
export function toggleThreadFollow(thread_id) {
	return { type: LUSER_TOGGLE_FOLLOW, thread_id };
}

export function threadFollow(thread_id) {
	return { type: LUSER_FOLLOW, thread_id };
}

export function threadUnfollow(thread_id) {
	return { type: LUSER_UNFOLLOW, thread_id };
}

export function checkFollowedIntegrity(){
	return { type: LUSER_CHECK_FOLLOWED_INTEGRITY };
 }



// WEBPACK FOOTER //
// ./src/redux/actions/luserAction.jsx